import $ from 'jquery';

$( document ).ready( function() {
	$( document.body ).on( 'click', '.acf-filter .filter-toggle', function( evt ) {
		const toggle          = $( this );
		const filterContainer = toggle.parent();

		evt.preventDefault();

		if ( toggle.hasClass( 'open' ) ) {
			filterContainer.find( '.filter-blocks' ).slideToggle( function() {
				toggle.removeClass( 'open' );
			} );
		} else {
			toggle.addClass( 'open' );
			setTimeout( function() {
				filterContainer.find( '.filter-blocks' ).slideToggle();
			}, 500 );
		}
	} );
	$( document.body ).on( 'click', '.acf-filter .filter-section .title', function( evt ) {
		const filterContainer = $( this ).parent();

		evt.preventDefault();

		filterContainer.toggleClass( 'open' );
		filterContainer.find( '.filter' ).slideToggle();
	} );
	$( document.body ).on( 'click', '.acf-filter .filter-section .wrap', function( evt ) {
		const filterContainer = $( this ).parent().parent();

		evt.preventDefault();

		$( this ).toggleClass( 'active' );
		filterContainer.toggleClass( 'active' );
	} );
	$( document.body ).on( 'click', '.acf-filter .filter-section .title .status', function( evt ) {
		const filterContainer = $( this ).parent().parent();

		evt.preventDefault();
		evt.stopPropagation();

		filterContainer.toggleClass( 'active' );
		filterContainer.find( '.wrap' ).toggleClass( 'active' );
	} );
	$( document.body ).on( 'click', '.acf-filter .extra-infos i,.acf-filter .extra-infos .infos', function( evt ) {
		const container = $( this ).parent();

		evt.preventDefault();
		evt.stopPropagation();

		container.toggleClass( 'open' );
	} );
} );

